export const titleJson = {
	allGarden: "allGarden",
	gardenPicNic: "gardenPicNic",
	gardenEden: "gardenEden",
	gardenZapata: "gardenZapata",
	soundSpace: "soundSpace",
	library: "library",
	cafeteria: "cafeteria",
	rectoria: "rectoria",
	culturalCenter: "culturalCenter",
	sportActivities: "sportActivities",
};

export const copysInformationModal = {
	allGarden: (
		<>
			<p>
				Los jardines de la UAM Xochimilco se integraron a los espacios arquitectónicos como patios interiores o áreas verdes, en donde la
				comunidad universitaria puede encontrar un lugar de relajación, esparcimiento, práctica de algunas actividades relacionadas con sus
				unidades de enseñanza aprendizaje, disfrutar del arte y la cultura y tener convivencia a lo largo de la jornada escolar y laboral.
			</p>
		</>
	),
	gardenPicNic: (
		<>
			<p>
				A este espacio también se le llama Jardín Día de Campo debido a que se encuentra la escultura del artista Gilberto Aceves Navarro,
				quien donó su obra Día de campo, inaugurada el lunes 27 de junio de 2005. La pieza monumental, construida con láminas rectas de acero
				al carbón y con la apariencia cobriza que le da el acabado en óxido natural, captura la mirada al ingresar a la UAM-X, no sólo por sus
				dimensiones de ocho metros por lado y nueve de altura, sino por el contraste de su color en el centro de una amplia extensión verde
				pasto. Además, en 2022, Félix Blume donó una pieza llamada Memoria del Hierro, una escultura sonora basada en grabaciones de sonido
				capturadas durante las protestas por la reforma energética en la Ciudad de México en 2013. Al golpear las barricadas metálicas de la
				policía que protegían el edificio del Senado, los manifestantes crearon una sonoridad que era representativa de la desaprobación. Una
				invitación visual y auditiva a sumergirnos en los recuerdos inscritos en el hierro. Acceso sur de calzada del Hueso
			</p>
		</>
	),
	gardenEden: (
		<>
			<p>
				Se encuentra en el claustro que forman los edificios A, B, D y G. Este espacio fue la primera área de la Unidad que integró un jardín
				con árboles, como ahuehuetes, pinos, palmeras y otros arbustos que brindan una sensación de paz a quienes transitan por ahí. En tiempo
				recientes se establecieron pequeñas ágoras donde los docentes pueden impartir sus módulos o simplemente convivir y relajarse.
			</p>
		</>
	),
	gardenZapata: (
		<>
			<p>
				Es un referente entre la comunidad estudiantil. En su ágora central, los alumnos encuentran un espacio de convivencia y recreación.
				Ahí se realizan diferentes actividades culturales, como performance, muestras de danza y exposiciones. También en ese espacio fue
				colocada en tiempos reciente la escultura en acero inoxidable Cumela, de la artista plástica Yvonne Domenge, para deleite de la
				comunidad universitaria. Se encuentra en el claustro que forman los edificios A, H y M.
			</p>
		</>
	),
	soundSpace: (
		<>
			<p>
				Es una instalación que consiste en la intervención sonora de un área verde específica. En el lugar se difunden diversas
				manifestaciones culturales sonoras y se llevan a cabo sesiones de escucha dirigidas, así como conciertos, programas de radio,
				conferencias y talleres, con el objetivo de difundir y conservar la cultura sonora. Se encuentra en el área verde ubicada frente al
				edificio L de profesores.
			</p>
		</>
	),
	library: (
		<>
			<p>
				La Biblioteca Ramón Villarreal Pérez pone a tu disposición diversas colecciones de materiales, contando con más de 300,000 libros
				impresos que abarcan todas las áreas temáticas de los planes académicos de licenciatura y posgrado que ofrece la Unidad Xochimilco,
				disponibles para su consulta y solicitud en préstamo a domicilio. Una de las colecciones a destacar son las Publicaciones de la UAM
				Xochimilco, conformada por libros, revistas, tesis, reportes, entre otros, resultado de la actividad académica, científica e
				investigadora de nuestra comunidad y a los cuales puedes acceder a través del <b>Repositorio Institucional XOOK</b>. Así mismo, podrás
				consultar la Biblioteca Digital UAM <b>(BIDIUAM)</b> una de las más grandes e importantes en Latinoamérica. A través de su buscador
				denominado servicio de descubrimiento, puedes recuperar información de 169 bases de datos, más de 500 mil libros digitales, 200 mil
				revistas electrónicas y miles de videos y tesis. Además, cuenta con laboratorios virtuales, gestores de referencias bibliográficas,
				sistemas antiplagio y acceso gratuito a la plataforma de cursos en línea: Coursera. Ingresa al portal web de la Biblioteca para conocer
				la variedad de recursos, servicios y trámites en línea, cuya finalidad es atender de manera ágil y oportuna las necesidades de las
				personas usuarias.
			</p>
			<br></br>
			<span>XOOK: </span>
			<span>
				<a href="https://repositorio.xoc.uam.mx" target="_blank" rel="noreferrer">
					https://repositorio.xoc.uam.mx
				</a>
			</span>
			<br></br>
			<span>BIDIUAM: </span>
			<span>
				<a href="https://bidi.uam.mx" target="_blank" rel="noreferrer">
					https://bidi.uam.mx
				</a>
			</span>
			<br></br>
			<span>Biblioteca: </span>
			<span>
				<a href="https://biblioteca.xoc.uam.mx" target="_blank" rel="noreferrer">
					https://biblioteca.xoc.uam.mx
				</a>
			</span>
			<br></br>
		</>
	),
	cafeteria: (
		<>
			<p>
				La Cafetería de la UAM Xochimilco presta los servicios de <span className="font-bold">Barra de alimentos calientes</span> : desayunos
				(de lunes a viernes de 9:00 a 11:30 h) y comidas (de lunes a viernes de 14:00 a 17:30 h). Así como
				<span className="font-bold">Barra de alimentos fríos</span> : donde se pueden adquirir algunos productos industrializados (lunes a
				viernes de 8:00 a 20:00 h). El personal de la cafetería se afana en que los alimentos se preparen, expendan y sirvan bajo las
				condiciones de higiene y seguridad necesarias para proteger la salud de la comunidad universitaria, y mantiene limpias las
				instalaciones, mobiliario y utensilios. Sus instalaciones se encuentran en el edificio C, junto al estacionamiento central.
			</p>
		</>
	),
	rectoria: (
		<>
			<p>
				Conformado por los edificios O, P y Q de la División de Ciencias y Artes para el Diseño, el Claustro es un espacio para la convivencia
				y el intercambio de ideas entre las y los estudiantes de Arquitectura, Diseño de la Comunicación Gráfica, Diseño Industrial y
				Planeación Territorial. El centro de este espacio es tutelado por un ahuehuete, árbol milenario que acompaña la vida universitaria, y
				en donde se realizan algunas actividades culturales, como danza, canto, muestras editoriales y diferentes manifestaciones académicas.
				Su acceso principal es por entre el edificio P y Q, y en su tercer piso aloja a la dirección de CyAD.
			</p>
		</>
	),
	culturalCenter: (
		<>
			<p>
				Desde que las actividades en la Unidad cambiaron su ritmo por la pandemia de SARS-COV-2, muchos de los espacios que conocemos en ella
				cambiaron su aspecto, pero al mismo tiempo, se llevaron a cabo proyectos arquitectónicos para generar nuevos espacios, como el Centro
				Cultural UAM Xochimilco. Aprobado el Programa de Transición de Enseñanza en la Modalidad Mixta (PROTEMM), en este regreso gradual a
				las actividades presenciales, encontraremos una explanada techada con una velaria: el Centro Cultural UAM Xochimilco. El objetivo de
				este nuevo espacio es brindar a la comunidad universitaria un recinto de 1,069.80 metros cuadrados donde desarrollar actividades
				académicas y culturales al aire libre. El Centro se encuentra ubicado en la explanada posterior a la biblioteca, en el acceso de
				calzada de la Bombas.
			</p>
		</>
	),
	sportActivities: (
		<>
			<p>
				La Unidad Xochimilco de la UAM cuenta con un gimnasio techado en donde se puede realizar cardio, acondicionamiento físico general y
				halterofilia. En las salas anexas se realizan actividades recreativas de ajedrez, tenis de mesa y spinning. Se cuenta también con
				vestidores y regaderas para mujeres y hombres, además en cada uno de ellos hay un baño con regadera para capacidades diferentes. El
				área administrativa se encuentra en el primer piso del edificio Z, donde puedes realizar trámites de inscripción a las actividades que
				se imparten. Esta sección tiene dos campos de fútbol soccer con medidas reglamentarias; una cancha de fútbol rápido; tres canchas de
				básquetbol y tres de voleibol. Además de la amplitud de todas las áreas verdes y un gimnasio al aire libre, existe un circuito de
				corredores con gravilla roja de 750 m de longitud en donde se puede practicar el atletismo. La entrada se ubica a un costado del
				edificio AB.
			</p>
		</>
	),
};
